import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What are Magento development services?",
    answer: `<p>Magento Development services consist of various offerings mainly focused on customizing, optimizing, and developing Magento-based ecommerce platforms.The most common services are website development, theme customization, extension integration, performance optimization, migration, maintenance, and ongoing support.</p>`,
  },
  {
    question: "How much does a Magento developer cost?",
    answer:`<p>The hourly rate for our expert Magento eCommerce developers starts at $50/hour to $99/hour and can vary based on experience, skills, project complexity, customization needs, and market conditions.</p>`,
  },
  {
    question: "How long does it take to develop a Magento ecommerce store?",
    answer: `<p>If you want to create a simple Magento store with basic features, then it will take six weeks. But if you have a complex idea in your mind related to your ecommerce store with multiple features, customization, integrations, and advanced functionality, the development process will take several months to a year. Our Magento website developers can give you an accurate time frame based on your project requirements.</p>`,
  },
  {
    question: "Is TekRevol capable of integrating Magento websites with third-party systems?",
    answer: `<p>At TekRevol, we are experts in seamlessly integrating Magento websites with other third-party systems including ERP, CRM, and multiple payment gateways. Our team of developers has years of experience in creating robust connections between Magento and external platforms.</p>`,
  },
  {
    question: "What is the cost of developing a Magento ecommerce website?",
    answer: `<p>The cost of developing a Magento e-commerce website can be estimated by multiple aspects, including the complexity of the project, customizations, needed features, integrations with third-party systems, ongoing support, and the expertise of the development team. We suggest you connect with our consultant to know the exact cost according to your project.</p>`,
  },
  {
    question: "Does TekRevol help with migrating an existing store to Magento?",
    answer: `<p>TekRevol does offer migration services to help businesses transition their existing stores to the Magento platform. We provide support and expertise in migrating from various platforms or older versions of Magento to Magento 2. This service includes data migration, ensuring a smooth transition while preserving essential store functionalities, data integrity, and SEO elements.</p>`,
  },
  {
    question: "Why TekRevol is the best choice for custom Magento development services?",
    answer: `<p>TekRevol as a top Magento development company specializes in tailoring Magento solutions to unique business needs, ensuring scalability and seamless integration with third-party systems. Our track record of successful projects and commitment to staying abreast of the latest Magento trends solidify our position as industry leaders. Choosing TekRevol means partnering with a dedicated team delivering innovative, high-quality, and personalized Magento solutions for sustained business growth.</p>`,
  },
];

function FaqLocation(props) {


  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Magento Development Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs}/>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
